import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponentModule } from './icon/icon-component.module';
import { ButtonComponentModule } from './button/button-component.module';
import { TooltipComponent } from './tooltip/tooltip.component';
import { IconButtonComponentModule } from './icon-button/icon-button-component.module';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { IconComponent } from './icon/icon.component';
import { ButtonComponent } from './button/button.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { SelectCheckboxComponent } from './select-checkbox/select-checkbox.component';
import { RadioGroupDirective } from './radio-button/radio-group.directive';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { MultiCalendarPanelComponent } from './date/multi-calendar-picker/multi-calendar-panel/multi-calendar-panel.component';
import { MultiCalendarPickerComponent } from './date/multi-calendar-picker/multi-calendar-picker.component';
import { DateRangePickerComponent } from './date/date-range-picker/date-range-picker.component';
import { DatePickerFocusDirective } from './date/shared/directives/date-picker-focus.directive';
import { TranslateModule } from '@ngx-translate/core';
import { SwitchComponent } from './switch/switch.component';
import { CurrencyInputComponent } from './currency-input/currency-input.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { ChipComponent } from './chip/chip.component';

@NgModule({
    declarations: [
        /**
         * Components / Directives/ Pipes
         */
        TooltipComponent,
        ButtonGroupComponent,
        SelectCheckboxComponent,
        RadioButtonComponent,
        RadioGroupDirective,
        DateRangePickerComponent,
        DatePickerFocusDirective,
        MultiCalendarPanelComponent,
        MultiCalendarPickerComponent,
        SwitchComponent,
        CurrencyInputComponent,
        ChipComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        IconComponentModule,
        IconButtonComponentModule,
        ButtonComponentModule,
        PipesModule
    ],
    exports: [
        TooltipComponent,
        IconComponent,
        ButtonGroupComponent,
        ButtonComponent,
        IconButtonComponent,
        SelectCheckboxComponent,
        RadioGroupDirective,
        RadioButtonComponent,
        DateRangePickerComponent,
        MultiCalendarPanelComponent,
        MultiCalendarPickerComponent,
        SwitchComponent,
        CurrencyInputComponent,
        ChipComponent
    ]
})

export class ElementsModule {
}